(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    const initAccordionRowsLimit = () => {
    document.querySelectorAll(".accordion__rows").forEach(function (wrapper) {
      const visibleRows = Number(wrapper.dataset.visibleRows) || 4;
      const rows = wrapper.querySelectorAll("accordion-custom");
      const button = wrapper.parentElement.querySelector(".accordion__toggle");

      if (!button) return;

      if (rows.length <= visibleRows) {
        button.hidden = true;
        // Reset visibility just in case theme settings changed in customizer
        rows.forEach(row => row.style.display = "");
        return;
      }

      let expanded = false;

      // Initial hide of excess rows
      rows.forEach(function (row, index) {
        if (index >= visibleRows) {
          row.style.display = "none";
        } else {
          row.style.display = ""; // Ensure visible rows show if limit changed
        }
      });

      button.hidden = false;
      button.textContent = "Read More";

      // Clone button to sweep away stale event loops during Theme Editor updates
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      newButton.addEventListener("click", function () {
        expanded = !expanded;
        rows.forEach(function (row, index) {
          if (index >= visibleRows) {
            row.style.display = expanded ? "" : "none";
          }
        });
        newButton.textContent = expanded ? "Read Less" : "Read More";
      });
    });
  };

  // Run immediately and listen for theme visual reloads
  document.addEventListener("DOMContentLoaded", initAccordionRowsLimit);
  document.addEventListener("shopify:section:load", initAccordionRowsLimit);
  } catch(e) { console.error(e); }
})();

})();
